<mat-form-field appearance="outline" class="full-width">
    <!-- <mat-label>{{ label }}</mat-label> -->
    <input matInput type="text" [placeholder]="placeholder" [formControl]="control" (input)="onInput($event)" (blur)="onBlur()" [attr.minlength]="isMinLengthRequired ? minLength : null"
    [attr.maxlength]="isMaxLengthRequired ? maxLength : null"/>
    <!-- <mat-error *ngIf="control?.dirty || control?.touched"> -->
    <mat-error *ngIf="control?.dirty || isSubmit">
        <span *ngIf="control?.hasError('required')">
            {{ errorMessage }}
        </span>
        <span *ngIf="control?.hasError('invalidPhone') && !control?.hasError('required')">
            {{errorMessagePhone}}
        </span>
    </mat-error>
</mat-form-field>
